import { html as n, repeat as s } from "@microsoft/fast-element";
const o = (l) => {
  const i = n.partial(l.prefix);
  return n`
    <div class="container" tabindex="0" @focusout=${(e) => e.handleFocusOut()}>
      <${i}-label
        class="label"
        part="label"
        style="${(e) => e.label && e.label.length > 0 ? "" : "display: none"}"
      >
        ${(e) => e.label}
      </${i}-label>
      <div class="chip-ai-variant">
        <div class="control" part="control">
          <div class="suggestion" @click=${(e) => e.handleSuggestionClick()}>
            <${i}-icon
              name=${(e) => "level-" + (e.confidence < 1 ? 1 : e.confidence > 3 ? 3 : e.confidence).toString()}
            ></${i}-icon>
            <div class="suggestion-value">${(e) => e.selectedValue}</div>
            <${i}-icon name="check"></${i}-icon>
          </div>
          <div class="dismiss" @click=${(e) => e.handleDismissClick()}>
            <${i}-icon name="x-mark"></${i}-icon>
          </div>
        </div>
        <div
          @click=${(e) => e.toggleDropMenu()}
          class="chip-action-more"
          style="${(e) => e.suggestions.length > 1 ? "" : "display: none"}"
        >
          <p>+${(e) => e.suggestions.length - 1}</p>
        </div>
      </div>
      <div
        class="drop-menu ${(e) => e.isExpanded ? "expanded" : "collapsed"}"
      >
        <div class="info-text">
          <p>${(e) => e.suggestions.length - 1} ${(e) => e.i18n.otherSuggestions}</p>
        </div>
        ${s(
    (e) => e.suggestions,
    n`
            <div
              class="chip-menu-item"
              @click=${(e, c) => c.parent.selectSuggestion(e)}
            >
              <div class="confidence-level">
                <${i}-icon
                  size="1rem"
                  name=${(e) => "level-" + (e.confidence < 1 ? 1 : e.confidence > 3 ? 3 : e.confidence).toString()}
                ></${i}-icon>
              </div>
              <p>${(e) => e.value}</p>
            </div>`
  )}
      </div>
    </div>
  `;
};
export {
  o as aiChipTemplate
};
